import React from 'react';
import { useNavigate } from 'react-router-dom';

/** Screen header: round back button + title + optional right-side slot. */
export const GDTop: React.FC<{
  title: string;
  backTo?: string;
  onBack?: () => void;
  right?: React.ReactNode;
}> = ({ title, backTo, onBack, right }) => {
  const navigate = useNavigate();
  return (
    <div className="gd-top">
      <button
        type="button"
        className="gd-back"
        aria-label="Back"
        onClick={() => (onBack ? onBack() : navigate(backTo || '/home'))}
      >
        ‹
      </button>
      <h2>{title}</h2>
      {right}
    </div>
  );
};

/** Centered success/status view (the mockup's "done" screens). */
export const GDDone: React.FC<{
  icon?: React.ReactNode;
  tone?: 'green' | 'orange';
  title: string;
  children?: React.ReactNode;
}> = ({ icon = '✓', tone = 'green', title, children }) => (
  <div className="gd-done-wrap">
    <div className={`gd-check${tone === 'orange' ? ' gd-orange' : ''}`}>{icon}</div>
    <h2>{title}</h2>
    {children}
  </div>
);

export const GDSpinnerScreen: React.FC<{ label?: string }> = ({ label }) => (
  <div className="gd-done-wrap">
    <div className="gd-spinner" />
    {label ? <p>{label}</p> : null}
  </div>
);

/** Progress dashes for the check-in wizard. */
export const GDSteps: React.FC<{ total: number; current: number }> = ({ total, current }) => (
  <div className="gd-steps">
    {Array.from({ length: total }, (_, i) => (
      <i key={i} className={i < current ? 'gd-on' : ''} />
    ))}
  </div>
);
